export const yellow = {
    50: "#fff8e0",
    100: "#ffedb0",
    200: "#ffe17c",
    300: "#ffd644",
    400: "#ffcc07",
    500: "#ffc300",
    600: "#ffb400",
    700: "#ffa100",
    800: "#ff8f00",
    900: "#ff6e00",
};

export const blue = {
    50: "#e5e8ee",
    100: "#bcc5d7",
    200: "#92a0bb",
    300: "#697ca0",
    400: "#49628e",
    500: "#27497e",
    600: "#214276",
    700: "#18396b",
    800: "#112f5e",
    900: "#092047",
};

export const meadowgreen = "#E6EC82";